// The toast after any copy-link that goes through withMyReferral
// (lib/referral/share): with a code it says the link carries it, so creators
// learn their shares can pay; without one it points at /earn. Takes t from
// the caller because the Toaster renders outside LocaleProvider (_app).
import React from "react";
import Link from "next/link";
import { toast } from "react-hot-toast";
import type { useT } from "@jammable/ui-core/src/i18n";
import { myReferralCode } from "../../lib/referral/share";

export function shareToast(t: ReturnType<typeof useT>) {
  if (myReferralCode()) {
    toast.success(
      <span>
        <b>{t("referral.share.copied")}</b>
        <br />
        {t("referral.share.copiedDetail")}
      </span>,
    );
    return;
  }
  toast.success(
    <span>
      <b>{t("referral.share.copiedPlain")}</b>
      <br />
      <Link href="/earn" className="tw-font-extrabold tw-text-jam-purple">
        {t("referral.share.earn")} →
      </Link>
    </span>,
  );
}
